import React, { useState } from "react";
import Modal from "./Modal";
import Button from "./Button";

const DateTime = ({ title, value, onChange, min, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ flex: 1 }}>
      <div className="date-label">{title}</div>
      <div style={{ width: "100%", overflow: "hidden", display: "flex" }}>
        <input
          type="datetime-local"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="form-control"
          min={min}
        />
      </div>
    </div>

    // <div>
    //   <div className="check-div-wrap">
    //     <div className="w100">
    //       <div>Start Date & Time</div>
    //       <input
    //         type="datetime-local"
    //         className="input-date"
    //         name="datetimes"
    //         value={start}
    //         onChange={onStartChange}
    //       />
    //     </div>
    //     <div>
    //       <div>End Date & Time</div>
    //       <input
    //         type="datetime-local"
    //         className="input-date"
    //         name="datetimes"
    //         min={min}
    //         value={end}
    //         onChange={onEndChange}
    //       />
    //     </div>
    //   </div>
    //   {isOpen && (
    //     <Modal
    //       setIsOpen={setIsOpen}
    //       data={
    //         <div style={{ minWidth: "500px" }} className="">
    //           <div className="df gap20 mb10">
    //             <div>
    //               <p>Start Date</p>
    //               <input
    //                 type="datetime-local"
    //                 className="form-control"
    //                 autoFocus
    //                 name="datetimes"
    //               />
    //             </div>
    //             <div>
    //               <p>End Date</p>
    //               <input
    //                 type="datetime-local"
    //                 className="form-control"
    //                 name="datetimes"
    //               />
    //             </div>
    //           </div>
    //           <div className="modal-btn">
    //             <Button title={"Save"} onClick={() => {}} />
    //             <Button title={"Cancel"} onClick={() => setIsOpen(false)} />
    //           </div>
    //         </div>
    //       }
    //     />
    //   )}
    // </div>
  );
};

export default DateTime;
